import {Grid, Typography, Box} from '@mui/material';

import {MetricItem} from './AnalyticsSection';
import {orangeColors} from '../../../../layouts/theme/designSystem';

interface Props {
  metrics: MetricItem[];
  gridRows?: number;
}

export const AnalyticsSectionRow = ({metrics, gridRows = 4}: Props) => {
  return (
    <Grid container justifyContent='space-between' spacing={2}>
      {metrics.map((metric, index) => (
        <Grid item xs={12} sm={gridRows} key={index}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              padding: 2,
              backgroundColor: orangeColors[5],
              border: '1px solid',
              borderRadius: '14px',
              borderColor: orangeColors[3],
            }}
          >
            <Typography variant='h4' gutterBottom>
              {metric.label}
            </Typography>
            <Typography variant='h3' fontWeight='bold'>
              {metric.value}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
